exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".BottomNavigationBar{position:relative;display:flex;align-items:center;margin:0 auto}", ""]);
